require('./compliance-forums.module.js');
require('./compliance-forums.route.js');

require('./search');
require('./components');
require('./discussions');
require('./forums');
require('./layouts');
require('./services');
